// File Metadata:
// Filename: EditVendorForm.js
// Version: 1.00
// Created: 2022-10-13 22:59:28
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState, useEffect } from 'react'
import { useUpdateVendorMutation, useDeleteVendorMutation } from '../api/vendorsApiSlice'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import useAuth from '../../hooks/useAuth'

const EditVendorForm = ({ vendor }) => {
	const { isVoorman, isAdmin } = useAuth()
	const [updateVendor, { isLoading, isSuccess, isError, error }] = useUpdateVendorMutation()
	const [deleteVendor, { isSuccess: isDelSuccess, isError: isDelError, error: delerror }] = useDeleteVendorMutation()

	const navigate = useNavigate()

	const [vendorName, setVendorName] = useState(vendor.vendorName)
	const [vendorNumber, setVendorNumber] = useState(vendor.vendorNumber)
	const [origin, setOrigin] = useState(vendor.origin)

	useEffect(() => {
		if (isSuccess || isDelSuccess) {
			setVendorName('')
			setVendorNumber('')
			setOrigin('')
			navigate('/dash/vendors')
		}
	}, [isSuccess, isDelSuccess, navigate])

	const onVendorNameChanged = e => setVendorName(e.target.value)
	const onVendorNumberChanged = e => setVendorNumber(e.target.value)
	const onOriginChanged = e => setOrigin(e.target.value)

	const canSave = [vendorName, vendorNumber, origin].every(Boolean) && !isLoading

	const onSaveVendorClicked = async e => {
		if (canSave) {
			await updateVendor({
				id: vendor.id,
				vendorName,
				vendorNumber,
				origin
			})
		}
	}

	const onDeleteVendorClicked = async () => {
		await deleteVendor({ id: vendor.id })
	}

	const created = new Date(vendor.createdAt).toLocaleString('en-US', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric'
	})
	const updated = new Date(vendor.updatedAt).toLocaleString('en-US', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric'
	})

	const errClass = isError ? 'errmsg' : 'offscreen'
	const validVendorNameClass = !vendorName ? 'form__input--incomplete' : ''
	const validVendorNumberClass = !vendorNumber ? 'form__input--incomplete' : ''
	const validOriginClass = !origin ? 'form__input--incomplete' : ''

	const errContent = (error?.data?.message || delerror?.data?.message) ?? ''

	let deleteButton = null
	if (isVoorman || isAdmin) {
		deleteButton = (
			<button className='icon-button' title='Delete' onClick={onDeleteVendorClicked}>
				<FontAwesomeIcon icon={faTrashCan} />
			</button>
		)
	}

	const saveButton = (
		<button className='icon-button' title='Save' onClick={onSaveVendorClicked} disabled={!canSave}>
			<FontAwesomeIcon icon={faSave} />
		</button>
	)

	/* start datagrid data for test */

	/*  */
	const content = (
		<>
			<p className={errClass}>{errContent}</p>

			<form className='form' onSubmit={e => e.preventDefault()}>
				<div className='form__title-row'>
					<h2>Edit Vendor</h2>
					<div className='form__action-buttons'>
						{saveButton}
						{deleteButton}
					</div>
				</div>
				<fieldset>
					<label className='form__label' htmlFor='vendorName'>
						Vendor Name:
						<input
							className={`form__input ${validVendorNameClass}`}
							id='vendorName'
							name='vendorName'
							type='text'
							autoComplete='off'
							value={vendorName}
							onChange={onVendorNameChanged}
						/>
					</label>
					<label className='form__label' htmlFor='vendorNumber'>
						Unload Location:
						<input
							className={`form__input ${validVendorNumberClass}`}
							id='vendorNumber'
							type='text'
							name='vendorNumber'
							value={vendorNumber}
							onChange={onVendorNumberChanged}
						/>
					</label>
					<label className='form__label form__checkbox-container' htmlFor='origin'>
						Unloaded By:
						<input
							className={`form__input ${validOriginClass}`}
							id='origin'
							name='origin'
							type='text'
							value={origin}
							onChange={onOriginChanged}
						/>
					</label>
				</fieldset>
				<div className='form__divider'>
					<p className='form__created'>
						Created:
						<br />
						{created}
					</p>
					<p className='form__updated'>
						Updated:
						<br />
						{updated}
					</p>
				</div>
			</form>
		</>
	)

	return content
}

export default EditVendorForm
